(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const raCollectionUrl = new URL(window.location.href);

  if (raCollectionUrl.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(raCollectionUrl.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }, { once: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-bestsellers"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'ra-bestsellers-v151';
  if (customElements.get(tag)) return;

  customElements.define(tag, class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-ra-bs-track]');
      this.previousButton = this.querySelector('[data-ra-bs-prev]');
      this.nextButton = this.querySelector('[data-ra-bs-next]');
      if (!this.track) return;

      this.busy = false;
      this.queue = [];
      this.drag = null;
      this.manualScrollTimer = null;
      this.suppressDragClick = false;
      this.suppressTimer = null;

      this.previousClick = () => this.enqueue(-1);
      this.nextClick = () => this.enqueue(1);
      this.previousButton?.addEventListener('click', this.previousClick);
      this.nextButton?.addEventListener('click', this.nextClick);

      this.onScroll = () => {
        if (this.busy || this.drag) return;
        clearTimeout(this.manualScrollTimer);
        this.manualScrollTimer = setTimeout(() => this.normalizeScroll(), 180);
      };
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.onHover = (event) => {
        if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        const gallery = event.target.closest?.('.ra-bs-item .card-gallery');
        if (!gallery || !this.track.contains(gallery)) return;
        const card = gallery.closest('.ra-bs-item[data-ra-bs-hover-src]');
        if (!card || gallery.querySelector('.ra-bs-second-image')) return;
        const link = gallery.querySelector('a.contents');
        if (!link) return;
        const image = document.createElement('img');
        image.className = 'ra-bs-second-image';
        image.alt = '';
        image.decoding = 'async';
        image.loading = 'lazy';
        image.src = card.dataset.raBsHoverSrc;
        link.appendChild(image);
      };
      this.track.addEventListener('pointerover', this.onHover);

      // Keep native image/title product links; price stays non-clickable.
      this.decorateAddLabels();
      this.prepareMobileImages();
      this.onSectionLoad = (event) => {
        if (event.target.contains(this)) {
          this.decorateAddLabels();
          this.prepareMobileImages();
        }
      };
      document.addEventListener('shopify:section:load', this.onSectionLoad);

      /* Horizon uses an absolute, whole-card product link. Its click target
         may cover the price even when the price has no <a> tag. Check the
         actual pointer position against the Shopify price element and cancel
         navigation only inside that rectangle. This also covers themes
         whose card-link stacking differs from the stock Horizon CSS. */
      this.onPriceClickCapture = (event) => {
        if (!(event instanceof MouseEvent)) return;
        if (event.detail === 0) return; // keyboard activation isn't a price click

        const target = event.target;
        if (!(target instanceof Element)) return;

        const item = target.closest('.ra-bs-item');
        if (!item || !this.track.contains(item)) return;

        const price = item.querySelector('product-price');
        if (!price) return;

        const bounds = price.getBoundingClientRect();
        const withinPrice =
          event.clientX >= bounds.left &&
          event.clientX <= bounds.right &&
          event.clientY >= bounds.top &&
          event.clientY <= bounds.bottom;

        if (!withinPrice) return;

        event.preventDefault();
        event.stopImmediatePropagation();
      };
      this.track.addEventListener('click', this.onPriceClickCapture, true);
      this.track.addEventListener('auxclick', this.onPriceClickCapture, true);

      // Desktop mouse drag from non-interactive card areas only.
      this.onPointerDown = (e) => this.beginDrag(e);
      this.onPointerMove = (e) => this.moveDrag(e);
      this.onPointerUp = (e) => this.endDrag(e);
      this.onPointerCancel = (e) => this.endDrag(e, true);
      this.onClickCapture = (e) => {
        if (!this.suppressDragClick) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        this.suppressDragClick = false;
        clearTimeout(this.suppressTimer);
      };
      this.track.addEventListener('pointerdown', this.onPointerDown);
      this.track.addEventListener('pointermove', this.onPointerMove);
      document.addEventListener('pointerup', this.onPointerUp);
      document.addEventListener('pointercancel', this.onPointerCancel);
      this.track.addEventListener('click', this.onClickCapture, true);

      // In mobile view the FIRST image tap shows image #2, the NEXT tap
      // follows the original Shopify product link. Product titles stay links.
      this.onMobileImageClick = (event) => this.mobileImageClick(event);
      this.track.addEventListener('click', this.onMobileImageClick, true);

      // The native gallery must not consume left/right touch gestures.
      // A touch release rotates the real product cards circularly instead.
      this.mobileTouch = null;
      this.onMobileTouchStart = (event) => this.mobileTouchStart(event);
      this.onMobileTouchMove = (event) => this.mobileTouchMove(event);
      this.onMobileTouchEnd = (event) => this.mobileTouchEnd(event);
      this.onMobileTouchCancel = () => { this.mobileTouch = null; };
      this.onMobilePointerGuard = (event) => this.mobilePointerGuard(event);
      this.track.addEventListener('touchstart', this.onMobileTouchStart, {capture:true,passive:true});
      this.track.addEventListener('touchmove', this.onMobileTouchMove, {capture:true,passive:false});
      this.track.addEventListener('touchend', this.onMobileTouchEnd, {capture:true,passive:true});
      this.track.addEventListener('touchcancel', this.onMobileTouchCancel, {capture:true,passive:true});
      for (const type of ['pointerdown', 'pointermove', 'pointerup']) {
        this.track.addEventListener(type, this.onMobilePointerGuard, true);
      }
    }

    disconnectedCallback() {
      if (this.drag?.active) this.cleanupDrag(this.drag);
      this.drag = null;
      this.previousButton?.removeEventListener('click', this.previousClick);
      this.nextButton?.removeEventListener('click', this.nextClick);
      this.track?.removeEventListener('scroll', this.onScroll);
      this.track?.removeEventListener('pointerover', this.onHover);
      this.track?.removeEventListener('pointerdown', this.onPointerDown);
      this.track?.removeEventListener('pointermove', this.onPointerMove);
      this.track?.removeEventListener('click', this.onClickCapture, true);
      this.track?.removeEventListener('click', this.onMobileImageClick, true);
      this.track?.removeEventListener('touchstart', this.onMobileTouchStart, true);
      this.track?.removeEventListener('touchmove', this.onMobileTouchMove, true);
      this.track?.removeEventListener('touchend', this.onMobileTouchEnd, true);
      this.track?.removeEventListener('touchcancel', this.onMobileTouchCancel, true);
      for (const type of ['pointerdown', 'pointermove', 'pointerup']) {
        this.track?.removeEventListener(type, this.onMobilePointerGuard, true);
      }
      this.track?.removeEventListener('click', this.onPriceClickCapture, true);
      this.track?.removeEventListener('auxclick', this.onPriceClickCapture, true);
      document.removeEventListener('pointerup', this.onPointerUp);
      document.removeEventListener('pointercancel', this.onPointerCancel);
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      clearTimeout(this.manualScrollTimer);
      clearTimeout(this.suppressTimer);
      this.queue.length = 0;
    }

    decorateAddLabels() {
      this.querySelectorAll('.ra-bs-item button.quick-add__button').forEach((button) => {
        if (button.querySelector('.ra-bs-add-label')) return;
        const label = button.classList.contains('quick-add__button--choose')
          ? this.dataset.chooseLabel : this.dataset.addLabel;
        const textNode = Array.from(button.childNodes).find(
          node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
        );
        if (!textNode) return;
        const span = document.createElement('span');
        span.className = 'ra-bs-add-label';
        span.textContent = label || textNode.textContent.trim();
        textNode.replaceWith(span);
      });
    }

    isMobile() {
      return matchMedia('(max-width: 749px)').matches;
    }

    ensureSecondImage(item, source, isMobileImage = false) {
      const gallery = item?.querySelector('.card-gallery');
      if (!gallery || !source) return null;
      let image = gallery.querySelector('.ra-bs-second-image');
      if (!image) {
        image = document.createElement('img');
        image.className = 'ra-bs-second-image';
        image.alt = '';
        image.decoding = 'async';
        image.loading = 'lazy';
        const target = gallery.querySelector('a.contents') || gallery;
        target.appendChild(image);
      }
      if (isMobileImage) {
        image.src = source;
      }
      return image;
    }

    prepareMobileImages() {
      if (!this.isMobile()) return;
      this.querySelectorAll('.ra-bs-item[data-ra-bs-mobile-src]').forEach(item => {
        const image = this.ensureSecondImage(item, item.dataset.raBsMobileSrc, true);
        if (image) image.loading = 'eager';
      });
    }

    mobileImageClick(event) {
      if (!this.isMobile() || event.detail === 0) return;
      const target = event.target;
      if (!(target instanceof Element)) return;
      const item = target.closest('.ra-bs-item');
      if (!item || !this.track.contains(item)) return;
      if (target.closest('button, .quick-add, quick-add-component, input, select, label, [role="button"]')) return;

      const gallery = item.querySelector('.card-gallery');
      if (!gallery) return;
      const b = gallery.getBoundingClientRect();
      const within = event.clientX >= b.left && event.clientX <= b.right &&
        event.clientY >= b.top && event.clientY <= b.bottom;
      if (!within) return;
      if (!item.dataset.raBsMobileSrc) return;

      if (!item.classList.contains('ra-bs-mobile-show-second')) {
        this.ensureSecondImage(item, item.dataset.raBsMobileSrc, true);
        item.classList.add('ra-bs-mobile-show-second');
        event.preventDefault();
        event.stopImmediatePropagation();
      } else if (!target.closest('a[href]')) {
        // Some Horizon cards expose the gallery as a non-anchor hit target.
        const anchor = item.querySelector('.card-gallery a[href], a.product-card__link[href], a[href*="/products/"]');
        if (anchor?.href) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (anchor.target === '_blank') window.open(anchor.href, '_blank', 'noopener');
          else window.location.assign(anchor.href);
        }
      }
    }

    mobilePointerGuard(event) {
      if (!this.isMobile() || event.pointerType !== 'touch') return;
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest('.card-gallery') && !target.closest('button, .quick-add, quick-add-component')) {
        // Keep Horizon's image slideshow from interpreting touch as image navigation.
        event.stopPropagation();
      }
    }

    mobileTouchStart(event) {
      if (!this.isMobile() || event.touches.length !== 1 || this.busy) return;
      const target = event.target;
      if (!(target instanceof Element) || !target.closest('.ra-bs-item')) return;
      if (target.closest('button, .quick-add, quick-add-component, input, select, textarea')) return;
      const touch = event.touches[0];
      this.mobileTouch = { x: touch.clientX, y: touch.clientY, dx: 0, dy: 0, moved: false };
      if (target.closest('.card-gallery')) event.stopPropagation();
    }

    mobileTouchMove(event) {
      if (!this.isMobile() || !this.mobileTouch || event.touches.length !== 1) return;
      const touch = event.touches[0];
      const gesture = this.mobileTouch;
      gesture.dx = touch.clientX - gesture.x;
      gesture.dy = touch.clientY - gesture.y;
      const horizontal = Math.abs(gesture.dx) > Math.abs(gesture.dy);
      if (horizontal && Math.abs(gesture.dx) > 10) {
        gesture.moved = true;
        if (event.cancelable) event.preventDefault();
      }
      if (event.target instanceof Element && event.target.closest('.card-gallery')) {
        event.stopPropagation();
      }
    }

    mobileTouchEnd(event) {
      const gesture = this.mobileTouch;
      this.mobileTouch = null;
      if (!gesture || !this.isMobile()) return;
      if (event.changedTouches.length) {
        const touch = event.changedTouches[0];
        gesture.dx = touch.clientX - gesture.x;
        gesture.dy = touch.clientY - gesture.y;
      }
      if (gesture.moved && Math.abs(gesture.dx) > 26 &&
          Math.abs(gesture.dx) > Math.abs(gesture.dy) * 1.15) {
        // Right swipe = previous product; left swipe = next product.
        this.enqueue(gesture.dx > 0 ? -1 : 1);
        this.suppressDragClick = true;
        clearTimeout(this.suppressTimer);
        this.suppressTimer = setTimeout(() => { this.suppressDragClick = false; }, 420);
      }
      if (event.target instanceof Element && event.target.closest('.card-gallery')) {
        event.stopPropagation();
      }
    }

    /* Start drag ONLY from blank space or the native whole-card backdrop. */
    beginDrag(e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || this.busy || this.drag) return;
      const target = e.target;
      if (!(target instanceof Element)) return;
      if (!target.closest('.ra-bs-item')) return;
      if (target.closest(
        'button, input, textarea, select, label, summary, [role="button"], ' +
        'quick-add-component, .quick-add, swatches-variant-picker-component, ' +
        'a:not(.product-card__link), [contenteditable="true"]'
      )) return;
      clearTimeout(this.manualScrollTimer);
      this.drag = {
        pointerId: e.pointerId,
        startX: e.clientX,
        startY: e.clientY,
        active: false,
        originalSnap: '',
        originalBehavior: '',
        ghosts: [],
        origin: 0
      };
    }

    moveDrag(e) {
      const d = this.drag;
      if (!d || e.pointerId !== d.pointerId) return;
      const dx = e.clientX - d.startX;
      const dy = e.clientY - d.startY;
      if (!d.active) {
        if (Math.abs(dx) < 6) return;
        if (Math.abs(dx) < Math.abs(dy)) {
          this.drag = null;
          return;
        }
        this.normalizeScroll(true);
        const originals = Array.from(this.track.querySelectorAll(':scope > .ra-bs-item'));
        if (originals.length < 2) {
          this.drag = null;
          return;
        }
        const step = this.getStep();
        if (!step) { this.drag = null; return; }

        d.active = true;
        d.originalSnap = this.track.style.scrollSnapType;
        d.originalBehavior = this.track.style.scrollBehavior;
        this.track.style.scrollSnapType = 'none';
        this.track.style.scrollBehavior = 'auto';
        // Inert images before and after provide enough overflow in either
        // direction without duplicating live Shopify forms or quick-add IDs.
        const before = originals.map(card => this.makeGhost(card));
        const after = originals.map(card => this.makeGhost(card));
        this.track.prepend(...before);
        this.track.append(...after);
        d.ghosts = [...before, ...after];
        d.origin = originals.length * step;
        this.track.scrollLeft = d.origin;
        this.track.classList.add('ra-bs-dragging');
        try { this.track.setPointerCapture(e.pointerId); } catch (_) {}
      }
      if (e.cancelable) e.preventDefault();
      this.track.scrollLeft = d.origin - dx;
    }

    endDrag(e, cancelled = false) {
      const d = this.drag;
      if (!d || e.pointerId !== d.pointerId) return;
      this.drag = null;
      if (!d.active) return;

      const step = this.getStep();
      const productCount = this.track.querySelectorAll(':scope > .ra-bs-item:not([data-ra-bs-ghost])').length;
      const moved = cancelled || !step ? 0 : Math.round((this.track.scrollLeft - d.origin) / step);
      this.cleanupDrag(d);
      if (productCount > 0 && moved !== 0) {
        // Move only genuine product nodes, then normalize at scrollLeft=0.
        const offset = ((moved % productCount) + productCount) % productCount;
        for (let i = 0; i < offset; i++) {
          this.track.append(this.track.firstElementChild);
        }
      }
      this.track.scrollLeft = 0;
      this.track.style.scrollSnapType = d.originalSnap;
      this.track.style.scrollBehavior = d.originalBehavior;
      this.suppressDragClick = true;
      clearTimeout(this.suppressTimer);
      this.suppressTimer = setTimeout(() => { this.suppressDragClick = false; }, 120);
    }

    cleanupDrag(d) {
      try {
        if (this.track.hasPointerCapture(d.pointerId)) this.track.releasePointerCapture(d.pointerId);
      } catch (_) {}
      this.track.classList.remove('ra-bs-dragging');
      d.ghosts.forEach(ghost => ghost.remove());
      this.track.style.scrollSnapType = 'none';
      this.track.style.scrollBehavior = 'auto';
    }

    makeGhost(source) {
      const clone = source.cloneNode(true);
      clone.dataset.raBsGhost = 'true';
      clone.setAttribute('inert', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.style.pointerEvents = 'none';
      clone.querySelectorAll('form, button, input, script, quick-add-component, add-to-cart-component')
        .forEach(el => el.remove());
      [clone, ...clone.querySelectorAll('*')].forEach(el => {
        el.removeAttribute('id');
        el.removeAttribute('ref');
        el.removeAttribute('href');
        for (const name of el.getAttributeNames()) {
          if (name.startsWith('on:')) el.removeAttribute(name);
        }
      });
      return clone;
    }

    getStep() {
      const item = this.track?.querySelector('.ra-bs-item');
      if (!item) return 0;
      const style = getComputedStyle(this.track);
      const gap = Number.parseFloat(style.columnGap || style.gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    enqueue(direction) {
      if (!this.track || this.track.children.length <= 1 || this.drag) return;
      this.queue.push(direction);
      if (!this.busy) void this.drain();
    }

    async drain() {
      this.busy = true;
      clearTimeout(this.manualScrollTimer);
      try {
        while (this.queue.length && this.isConnected) {
          await this.rotate(this.queue.shift());
        }
      } finally {
        this.busy = false;
      }
    }

    async rotate(direction) {
      const track = this.track;
      if (!track) return;
      this.normalizeScroll(true);
      const step = this.getStep();
      if (step < 1) return;
      const previousSnap = track.style.scrollSnapType;
      const previousBehavior = track.style.scrollBehavior;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      const ghosts = [];
      try {
        if (direction < 0) {
          track.prepend(track.lastElementChild);
          this.addVisualBuffers(step, ghosts);
          track.scrollLeft = step;
          await this.frames(2);
          track.scrollTo({ left: 0, behavior: reduced ? 'instant' : 'smooth' });
          if (!reduced) await this.waitForPosition(0);
        } else {
          this.addVisualBuffers(step, ghosts);
          await this.frames(1);
          track.scrollTo({ left: step, behavior: reduced ? 'instant' : 'smooth' });
          if (!reduced) await this.waitForPosition(step);
          track.append(track.firstElementChild);
          track.scrollLeft = 0;
        }
      } finally {
        ghosts.forEach(ghost => ghost.remove());
        track.scrollLeft = 0;
        await this.frames(1);
        track.style.scrollSnapType = previousSnap;
        track.style.scrollBehavior = previousBehavior;
      }
    }

    addVisualBuffers(step, ghosts) {
      let safety = 0;
      while (this.track.scrollWidth - this.track.clientWidth < step - 2 && safety < 18) {
        const source = this.track.children[ghosts.length % this.track.children.length];
        if (!source) break;
        const clone = this.makeGhost(source);
        this.track.append(clone);
        ghosts.push(clone);
        safety++;
      }
    }

    waitForPosition(target) {
      return new Promise(resolve => {
        const started = performance.now();
        const check = () => {
          if (!this.isConnected || Math.abs(this.track.scrollLeft - target) < 2 ||
              performance.now() - started > 650) resolve();
          else requestAnimationFrame(check);
        };
        requestAnimationFrame(check);
      });
    }

    frames(count) {
      return new Promise(resolve => {
        const next = () => {
          if (--count <= 0) resolve();
          else requestAnimationFrame(next);
        };
        requestAnimationFrame(next);
      });
    }

    normalizeScroll(force = false) {
      if (!this.track || (this.busy && !force) || (this.drag && !force)) return;
      const step = this.getStep();
      if (step <= 0) return;
      const count = Math.min(
        this.track.children.length - 1,
        Math.floor((this.track.scrollLeft + step / 2) / step)
      );
      if (count === 0) {
        if (force) this.track.scrollLeft = 0;
        return;
      }
      const originalSnap = this.track.style.scrollSnapType;
      const originalBehavior = this.track.style.scrollBehavior;
      this.track.style.scrollSnapType = 'none';
      this.track.style.scrollBehavior = 'auto';
      for (let i = 0; i < count; i++) this.track.append(this.track.firstElementChild);
      this.track.scrollLeft = 0;
      if (force) {
        this.track.style.scrollSnapType = originalSnap;
        this.track.style.scrollBehavior = originalBehavior;
      } else {
        requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.track.style.scrollSnapType = originalSnap;
          this.track.style.scrollBehavior = originalBehavior;
        });
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-designed-to-mean-more"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ra-energy-carousel')) return;

    customElements.define('ra-energy-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ra-energy-track]');
        this.prev = this.querySelector('[data-ra-energy-prev]');
        this.next = this.querySelector('[data-ra-energy-next]');
        if (!this.track) return;

        this.originals = Array.from(this.track.querySelectorAll(':scope > [data-ra-real]'));
        this.count = this.originals.length;
        this.buffer = 5;
        this.drag = null;
        this.moving = false;
        this.queue = [];
        this.wrapLock = false;
        this.suppressNextClick = false;
        this.motionTimer = null;
        this.scrollFrame = 0;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (this.count > 1) this.mountClones();

        this.onScroll = () => {
          if (!this.drag) this.wrapIfNeeded();
          this.scheduleCenter();
        };
        this.onResize = () => this.resetPosition();
        this.onPrev = () => this.enqueue(-1);
        this.onNext = () => this.enqueue(1);
        this.onDown = (event) => this.pointerDown(event);
        this.onMove = (event) => this.pointerMove(event);
        this.onUp = (event) => this.pointerUp(event);
        this.onClick = (event) => {
          if (!this.suppressNextClick) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressNextClick = false;
          clearTimeout(this.motionTimer);
        };
        this.onDragStart = event => event.preventDefault();
        this.onKeys = event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.enqueue(-1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); this.enqueue(1); }
        };

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('pointerdown', this.onDown);
        this.track.addEventListener('click', this.onClick, true);
        this.track.addEventListener('dragstart', this.onDragStart);
        this.track.addEventListener('keydown', this.onKeys);
        window.addEventListener('pointermove', this.onMove, { passive: false });
        window.addEventListener('pointerup', this.onUp);
        window.addEventListener('pointercancel', this.onUp);
        window.addEventListener('resize', this.onResize);
        this.prev?.addEventListener('click', this.onPrev);
        this.next?.addEventListener('click', this.onNext);

        this.resetPosition();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.track?.removeEventListener('pointerdown', this.onDown);
        this.track?.removeEventListener('click', this.onClick, true);
        this.track?.removeEventListener('dragstart', this.onDragStart);
        this.track?.removeEventListener('keydown', this.onKeys);
        window.removeEventListener('pointermove', this.onMove);
        window.removeEventListener('pointerup', this.onUp);
        window.removeEventListener('pointercancel', this.onUp);
        window.removeEventListener('resize', this.onResize);
        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
        clearTimeout(this.motionTimer);
        cancelAnimationFrame(this.scrollFrame);
        this.track?.querySelectorAll(':scope > [data-ra-clone]').forEach(node => node.remove());
      }

      makeClone(source) {
        const node = source.cloneNode(true);
        node.removeAttribute('data-ra-real');
        node.setAttribute('data-ra-clone', '');
        node.setAttribute('aria-hidden', 'true');
        node.removeAttribute('data-shopify-editor-block');
        node.removeAttribute('data-shopify-block');
        [node, ...node.querySelectorAll('*')].forEach(el => {
          el.removeAttribute('id');
          el.removeAttribute('data-shopify-editor-block');
          el.removeAttribute('data-shopify-block');
        });
        node.querySelectorAll('a').forEach(a => a.setAttribute('tabindex', '-1'));
        return node;
      }

      mountClones() {
        const before = [];
        const after = [];
        for (let i = this.buffer; i > 0; i--) {
          before.push(this.makeClone(this.originals[(this.count - (i % this.count)) % this.count]));
        }
        for (let i = 0; i < this.buffer; i++) {
          after.push(this.makeClone(this.originals[i % this.count]));
        }
        this.track.prepend(...before);
        this.track.append(...after);
      }

      stride() {
        const card = this.track.querySelector('.ra-energy-card');
        if (!card) return 0;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      resetPosition() {
        if (this.drag || this.moving) return;
        const step = this.stride();
        if (!step) return;
        const oldBehavior = this.track.style.scrollBehavior;
        const oldSnap = this.track.style.scrollSnapType;
        this.track.style.scrollBehavior = 'auto';
        this.track.style.scrollSnapType = 'none';
        this.track.scrollLeft = this.count > 1 ? this.buffer * step : 0;
        requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.track.style.scrollBehavior = oldBehavior;
          this.track.style.scrollSnapType = oldSnap;
          this.updateCenter();
        });
      }

      wrapIfNeeded() {
        if (this.count < 2 || this.wrapLock) return;
        const step = this.stride();
        if (!step) return;
        const pos = this.track.scrollLeft;
        const end = (this.buffer + this.count) * step;
        let next = null;
        if (pos <= 1) next = pos + this.count * step;
        else if (pos >= end - 1) next = pos - this.count * step;
        if (next === null) return;
        this.wrapLock = true;
        const oldBehavior = this.track.style.scrollBehavior;
        const oldSnap = this.track.style.scrollSnapType;
        this.track.style.scrollBehavior = 'auto';
        this.track.style.scrollSnapType = 'none';
        this.track.scrollLeft = next;
        requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.track.style.scrollBehavior = oldBehavior;
          this.track.style.scrollSnapType = oldSnap;
          this.wrapLock = false;
          this.updateCenter();
        });
      }

      scheduleCenter() {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = 0;
          this.updateCenter();
        });
      }

      updateCenter() {
        const rect = this.track.getBoundingClientRect();
        const center = rect.left + rect.width / 2;
        let best = null;
        let distance = Infinity;
        const nodes = this.track.querySelectorAll(':scope > .ra-energy-card');
        nodes.forEach(card => {
          const r = card.getBoundingClientRect();
          const d = Math.abs((r.left + r.right) / 2 - center);
          if (d < distance) { best = card; distance = d; }
        });
        nodes.forEach(card => card.classList.toggle('is-center', card === best));
      }

      enqueue(direction) {
        if (this.count < 2 || this.drag) return;
        this.queue.push(direction);
        if (!this.moving) void this.drain();
      }

      async drain() {
        this.moving = true;
        try {
          while (this.queue.length && this.isConnected) {
            await this.advance(this.queue.shift());
          }
        } finally {
          this.moving = false;
        }
      }

      advance(direction) {
        const step = this.stride();
        if (!step) return Promise.resolve();
        const target = (Math.round(this.track.scrollLeft / step) + direction) * step;
        const behavior = this.reduceMotion.matches ? 'auto' : 'smooth';
        this.track.scrollTo({ left: target, behavior });
        if (behavior === 'auto') {
          this.wrapIfNeeded();
          this.scheduleCenter();
          return Promise.resolve();
        }
        return new Promise(resolve => {
          const started = performance.now();
          const check = () => {
            if (!this.isConnected) return resolve();
            const now = this.track.scrollLeft;
            const equivalent = this.count * step;
            if (
              Math.abs(now - target) < 2 ||
              Math.abs(now - (target - equivalent)) < 2 ||
              Math.abs(now - (target + equivalent)) < 2 ||
              performance.now() - started > 750
            ) {
              this.wrapIfNeeded();
              return resolve();
            }
            requestAnimationFrame(check);
          };
          requestAnimationFrame(check);
        });
      }

      pointerDown(event) {
        if (event.pointerType !== 'mouse' || event.button !== 0 || this.moving) return;
        if (!event.target.closest('.ra-energy-card')) return;
        this.drag = {
          id: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          lastX: event.clientX,
          active: false
        };
      }

      pointerMove(event) {
        const d = this.drag;
        if (!d || d.id !== event.pointerId) return;
        const dx = event.clientX - d.startX;
        const dy = event.clientY - d.startY;
        if (!d.active) {
          if (Math.abs(dx) < 7) return;
          if (Math.abs(dx) < Math.abs(dy)) { this.drag = null; return; }
          d.active = true;
          this.track.classList.add('is-dragging');
          this.track.style.scrollSnapType = 'none';
          this.track.style.scrollBehavior = 'auto';
          d.lastX = d.startX;
        }
        if (event.cancelable) event.preventDefault();
        this.track.scrollLeft -= event.clientX - d.lastX;
        d.lastX = event.clientX;
        this.wrapIfNeeded();
        this.scheduleCenter();
      }

      pointerUp(event) {
        const d = this.drag;
        if (!d || d.id !== event.pointerId) return;
        this.drag = null;
        if (!d.active) return;
        this.track.classList.remove('is-dragging');
        const step = this.stride();
        this.track.style.scrollBehavior = '';
        this.track.style.scrollSnapType = '';
        if (step) {
          const snap = Math.round(this.track.scrollLeft / step) * step;
          this.track.scrollTo({ left: snap, behavior: this.reduceMotion.matches ? 'auto' : 'smooth' });
        }
        this.suppressNextClick = true;
        clearTimeout(this.motionTimer);
        this.motionTimer = setTimeout(() => { this.suppressNextClick = false; }, 250);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-featured-collection-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__raFeatureMobileFitV14) return;
  window.__raFeatureMobileFitV14 = true;
  const media = window.matchMedia('(max-width: 749px)');
  let raf = 0;

  function apply() {
    raf = 0;
    document.querySelectorAll('[id^="ra-feature-"] [data-ra-mobile-fit]').forEach((element) => {
      if (!media.matches || !element.isConnected) {
        element.style.removeProperty('font-size');
        return;
      }
      const maxSize = parseFloat(element.dataset.raMobileFit) || 20;
      const minSize = parseFloat(element.dataset.raFitMin) || 8;
      element.style.fontSize = `${maxSize}px`;
      if (element.scrollWidth <= element.clientWidth + 1) return;

      // Binary search the largest fitting size; no clipping/ellipses.
      let low = Math.min(maxSize, minSize);
      let high = maxSize;
      for (let attempt = 0; attempt < 12; attempt += 1) {
        const middle = (low + high) / 2;
        element.style.fontSize = `${middle}px`;
        if (element.scrollWidth > element.clientWidth + 1) high = middle;
        else low = middle;
      }
      element.style.fontSize = `${low}px`;
    });
  }

  function schedule() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  if (document.fonts?.ready) document.fonts.ready.then(schedule);
})();

  } catch(e) { console.error(e); }
})();
})();
